import { useState } from "react";
import OtpInput, { OTP_LENGTH } from "../../../auth/components/OtpInput";
import { Button } from "../../../design-v2";

const STEP_UP_ERROR_COPY = Object.freeze({
  OTP_EXPIRED: "That code expired. Request a new code and try again.",
  OTP_ATTEMPTS_EXCEEDED: "Too many attempts. Request a new code and try again.",
  OTP_INVALID: "That code is not valid. Check it and try again.",
});

export default function StepUpVerification({ sentTo, onVerify, onCancel }) {
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [isVerifying, setIsVerifying] = useState(false);

  async function handleSubmit(event) {
    event.preventDefault();
    if (code.length !== OTP_LENGTH || isVerifying) {
      return;
    }

    setIsVerifying(true);
    setError("");
    try {
      await onVerify(code);
    } catch (verifyError) {
      setCode("");
      setError(
        STEP_UP_ERROR_COPY[verifyError?.code] ||
        "We couldn't verify that code. Please try again."
      );
    } finally {
      setIsVerifying(false);
    }
  }

  return (
    <form
      className="lz-settings-step-up"
      onSubmit={handleSubmit}
      aria-label="Verify it's you"
    >
      <div>
        <p className="lz-settings-primary-text">Verify it’s you</p>
        <p className="lz-settings-hint">
          Enter the code sent to {sentTo || "your email address"}.
        </p>
      </div>
      <OtpInput
        value={code}
        onChange={(value) => {
          setCode(value);
          setError("");
        }}
        error={Boolean(error)}
        disabled={isVerifying}
        ariaLabel="Step-up verification code"
      />
      {error ? (
        <p className="lz-settings-error" role="alert">
          {error}
        </p>
      ) : null}
      <div className="flex gap-3">
        <Button
          type="button"
          variant="secondary"
          className="flex-1"
          disabled={isVerifying}
          onClick={onCancel}
        >
          Cancel
        </Button>
        <Button
          type="submit"
          className="flex-1"
          disabled={isVerifying || code.length !== OTP_LENGTH}
          isLoading={isVerifying}
          loadingLabel="Verifying..."
        >
          Verify
        </Button>
      </div>
    </form>
  );
}

export { STEP_UP_ERROR_COPY };
